export const apiBaseUrl =
  process.env.NODE_ENV === 'development'
    ? `http://${window.location.hostname}:8080`
    : 'https://plan-api.foodprep.lv';
